import Grid2 from "@mui/material/Unstable_Grid2";
import { useRoiIndustryContext } from "../../../context/roi/industry/RoiIndustryContext";
import { Box, Paper, Typography } from "@mui/material";
import RoiIndustry from "./RoiIndustry";
import RoiIndustryStocks from "./RoiIndustryStocks";
import useResponsive from "../../../components/hooks/useResponsive";
import NotFound from "../../../components/notfound/NotFound";
import RoiIndustriesFilters from "./RoiIndustriesFilters";
import RoiIndustriesSkeleton from "./RoiIndustriesSkeleton";

export const RoiIndustries = () => {
  const { filteredIndustries, isLoading } = useRoiIndustryContext();
  const { isMd } = useResponsive();

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "14px",
        minHeight: "88vh",
      }}
    >
      {/* show selected industry stocks  */}
      <RoiIndustryStocks />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: isMd && "center",
          flexDirection: !isMd && "column",
          gap: "12px",
        }}
      >
        <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
          بازدهی به تفکیک صنعت
        </Typography>

        {/* filters  */}
        <RoiIndustriesFilters />
      </Box>

      {isLoading ? (
        <RoiIndustriesSkeleton />
      ) : !filteredIndustries.length ? (
        <Box sx={{ height: "77vh" }}>
          <NotFound />
        </Box>
      ) : (
        <Grid2 container spacing={"14px"}>
          {filteredIndustries?.map((data, i) => (
            <Grid2 key={i} xs={6} sm={4} md={3} lg={2} xl={1.5}>
              <RoiIndustry data={data} />
            </Grid2>
          ))}
        </Grid2>
      )}
    </Paper>
  );
};
